import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';


@Component({
    selector: 'app-image-package',
    templateUrl: './image-package.component.html',
    styleUrls: ['./image-package.component.scss']
})

export class ImagePackageComponent implements OnInit {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<any>) {
    }

    ngOnInit(): void {
    }
}
